/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';
import { error } from '@/libs/notification';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';

export default {
  namespaced: true,
  state: {
    listData: [],
    loading: false
  },
  mutations: {
    setListData(state: any, payload: any[]) {
      state.listData = payload;
    },
    setLoading(state: any, payload: boolean) {
      state.loading = payload;
    }
  },
  actions: {
    async fetch(context: any, financeId: number) {
      context.commit('setLoading', true);
      try {
        const { data } = await axios.get(
          getBaseUrl() + '/master/mccs/finance-settings',
          {
            params: { financeId },
            headers: { auth: await getAccessToken() }
          }
        );
        context.commit('setListData', data);
      } catch (e: any) {
        if (e.response.status === 401) {
          await handleAuthorizationError();
        } else {
          error(e.response.status, 'ファイナンス設定取得に失敗しました');
        }
      } finally {
        context.commit('setLoading', false);
      }
    },
    async create(context: any, newRows: any[]) {
      await axios
        .post(getBaseUrl() + '/master/mccs/finance-settings/bulk', newRows, {
          headers: { auth: await getAccessToken() }
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else {
            throw e;
          }
        });
    },
    async update(context: any, updateRows: any[]) {
      await axios
        .patch(
          getBaseUrl() + '/master/mccs/finance-settings/bulk',
          updateRows,
          {
            headers: { auth: await getAccessToken() }
          }
        )
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else {
            throw e;
          }
        });
    }
  }
};
